import { useState, useEffect } from 'react'
import { Nav, NavItem, NavLink, Spinner } from 'reactstrap'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import usePartners from '../query/hooks/usePartners'
import useGetSponsorObjects from '../query/hooks/useGetSponsorObjects'

const PartnerTabs = ({onClickTab}) => {
  const [activeTab, setActiveTab] = useState(0)
  const {data: partners, isFetching: isFetchingPartners} = usePartners();
  const {data: sponsorObjects, isFetching: isFetchingSponsorObjects} = useGetSponsorObjects();

  const { t } = useTranslation()

  const isSinglePartner = partners.length === 1;
  const isFetching = isFetchingPartners || isFetchingSponsorObjects;

  // Auto-select single partner on mount
  useEffect(() => {
    if (isSinglePartner && partners[0]?.id && activeTab === 0) {
      setActiveTab(1)
      onClickTab(1, partners[0].id)
    }
  }, [isSinglePartner, partners, onClickTab, activeTab])

  function toggleTab(tabIndex, partnerId) {
    if (activeTab !== tabIndex) {
      setActiveTab(tabIndex)
      onClickTab(tabIndex, partnerId)
    }
  }

  function getTabName(partner) {
    // For single partner, use sponsor object name if available
    if (isSinglePartner && sponsorObjects?.length > 0) {
      return sponsorObjects[0].name;
    }
    return partner.name;
  }

  function renderTab(tab, index) {
    return (
      <NavItem key={index+1}>
        <NavLink
          href="#"
          className={classnames({
            active: activeTab === index+1
          })}
          onClick={() => {
            toggleTab(index+1, tab.id)
          }}
        >
          {getTabName(tab)}
        </NavLink>
      </NavItem>
    );
  };


  return (
    <div className="flex align-items-center">
      {isFetching && (
        <div className="mr-4">
          <Spinner />
        </div>
      )}
      {
        partners.length > 0 && (
          <Nav tabs className="nav-tabs-custom mb-4 mt-4 flex-fill">
            {!isSinglePartner && (
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === 0
                  })}
                  onClick={() => {
                    toggleTab(0, 0)
                  }}
                >
                  <span className="d-none d-sm-block">{t('Portfolio')}</span>
                </NavLink>
              </NavItem>
            )}
            {partners.map((tab, index) => renderTab(tab, index))}
          </Nav>
        )
      }
    </div>
  )
}


export default PartnerTabs;
